import React from 'react';
import StaffWorkStandardsGeneric from './generics/StaffWorkStandardsGeneric';
import { checkPersonalDataProtectionFileAction, downloadPersonalDataProtectionDocumentAction } from '../../services/request';

export default function StaffPersonalDataProtectionDocuments ({ manager }) {
  return (
    <StaffWorkStandardsGeneric
      manager={manager}
      downloadDocumentAction={downloadPersonalDataProtectionDocumentAction}
      checkDocumentAction={checkPersonalDataProtectionFileAction}
      title="Dokumentacja dotycząca ochrony danych osobowych"
      serializerFieldName="personal_data_protection_documents"
      showChecked={false}
    />
  );
};
